<template>
  <div>
    <div class="mt-2 mb-2">
      <p>
        Selecciona los colores que representen mejor la identidad de tu marca. Estos se aplicarán a insignias y botones,
        creando una experiencia de compra coherente y personalizada para tus clientes. Recomendamos utilizar colores
        que garanticen contraste y legibilidad.
      </p>
    </div>
    <div>
      <ul class="mb-1 pt-1 pl-1 d-flex justify-content-around">
        <li class="col-6 col-md-6 col-lg-3 mr-2">
          <span title="insignias">Selecciona un color para las <strong>insignias</strong>.</span>
          <color-picker id="badges_color" :color.sync="form.badges_color" class="mt-2"></color-picker>
        </li>
        <li class="col-6 col-md-6 col-lg-3">
          <span title="botones">Selecciona un color para los <strong>botones</strong>.</span>
          <color-picker id="buttons_color" :color.sync="form.buttons_color" class="mt-2"></color-picker>
        </li>
      </ul>
    </div>
    <div class="w-full d-flex justify-content-end mt-3 mb-4">
      <b-button :disabled="!canProceed" @click="continuar" class="push-right custom-btn-create" variant="warning">
        <b-spinner small v-if="loading.create"/>
        <span v-else>Continuar </span>
      </b-button>
    </div>
  </div>
</template>

<script>
import ColorPicker from '@/views/components/custom/color-picker/ColorPicker.vue'

export default {
  components: { ColorPicker },
  props: {
    badgesColor: {
      type: String,
      default: ''
    },
    buttonsColor: {
      type: String,
      default: ''
    },
    canContinue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const defaultColor = '#B0B0B0'
    return {
      form: {
        badges_color: this.badgesColor || defaultColor,
        buttons_color: this.buttonsColor || defaultColor
      },
      initialForm: null,
      loadingSpinner: true,
      loading: {
        create: false,
        awaiting: true
      }
    }
  },
  computed: {
    formIsDirty() {
      if (!this.initialForm) return false
      return (
        (this.initialForm.badges_color !== undefined &&
          this.initialForm.badges_color !== this.form.badges_color) ||
        (this.initialForm.buttons_color !== undefined &&
        this.initialForm.buttons_color !== this.form.buttons_color)
      )
    },
    canProceed() {
      return this.canContinue && !this.loading.create && this.formIsDirty && !(this.form.badges_color === '#B0B0B0' && this.form.buttons_color === '#B0B0B0')
    }
  },
  watch: {
    form: {
      handler(form) {
        const badgesChanged = this.initialForm && form.badges_color !== this.initialForm.badges_color && form.badges_color !== '#B0B0B0'
        const buttonsChanged = this.initialForm && form.buttons_color !== this.initialForm.buttons_color && form.buttons_color !== '#B0B0B0'
        this.$emit('colors-customized', badgesChanged && buttonsChanged)
        // this.$emit('colors-customized', !!(form.badges_color && form.buttons_color))
      },
      deep: true
    },
    badgesColor(newVal) {
      this.form.badges_color = newVal || '#B0B0B0'
    },
    buttonsColor(newVal) {
      this.form.buttons_color = newVal || '#B0B0B0'
    }
  },
  mounted() {
    // Clonamos el estado inicial del formulario una vez que el componente se monta
    this.initialForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    async continuar() {
      this.loading.create = true
      this.$emit('continuar', {
        badges_color: this.form.badges_color,
        buttons_color: this.form.buttons_color
      })
      this.loading.create = false
      this.loadingSpinner = false
    }
  }
}
</script>